import { AngularMaterialModule } from "./angular-material.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { CookieService } from "ngx-cookie-service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ForZeroFourComponent } from "./components/for-zero-four/for-zero-four.component";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { HttpInterceptorService } from "./api/http-interceptor.service";
import { LogInComponent } from "./components/log-in/log-in.component";
import { NgModule } from "@angular/core";
import { NgxSpinnerModule } from "ngx-spinner";
import { PaymentComponent } from "./components/payment/payment.component";
import { PlanComponent } from "./components/plan/plan.component";
import { SmsBuyComponent } from "./components/sms-buy/sms-buy.component";
import { BiometricBuyComponent } from "./components/biometric-buy/biometric-buy.component";
import { ToastrModule } from "ngx-toastr";
import { AppLayoutComponent } from "./components/app-layout/app-layout.component";
import { InvoiceDialogComponent } from "./components/plan/invoice-dialog/invoice-dialog.component";
import { BillingStepComponent } from "./components/billing-step/billing-step.component";
import { ReviewPayComponent } from "./components/review-pay/review-pay.component";
import { UserInfoCardComponent } from "./shared/components/user-info-card/user-info-card.component";
import { GymBranchSelectionCardComponent } from "./shared/components/gym-branch-selection-card/gym-branch-selection-card.component";
import { SimpleStepperComponent } from "./shared/components/simple-stepper/simple-stepper.component";

@NgModule({ declarations: [
        AppComponent,
        LogInComponent,
        PlanComponent,
        BillingStepComponent,
        ReviewPayComponent,
        ForZeroFourComponent,
        PaymentComponent,
        SmsBuyComponent,
        BiometricBuyComponent,
        AppLayoutComponent,
        InvoiceDialogComponent,
        UserInfoCardComponent,
        GymBranchSelectionCardComponent,
        SimpleStepperComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        AngularMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        ToastrModule.forRoot(), // ToastrModule added,
        NgxSpinnerModule], providers: [
        CookieService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
